import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { UserContext } from '../../../services/context/user.context.service';

@Directive({
  selector: '[appScope]',
})
export class HasScopeDirective implements OnInit {
  @Input('appScope') scope = '';

  constructor(private readonly _usrCtxSvc: UserContext, private readonly _emelentRef: ElementRef) {
    //FIXME only for testing porpuse
    //_emelentRef.nativeElement.style.backgroundColor = 'yellow';
  }

  ngOnInit(): void {
    const show = this._usrCtxSvc.userHasOperation(this.scope);
    if (!show) {
      const htmlElement: HTMLElement = this._emelentRef.nativeElement;
      htmlElement.parentNode?.removeChild(htmlElement);
    }
  }
}
